import LegalPageLayout from "@/components/LegalPageLayout";
import { COMPANY } from "@shared/company-info";

/**
 * Instruções de exclusão de dados.
 *
 * Existe por duas razões: o art. 18 da LGPD (direito de eliminação) e a
 * exigência da Meta de uma "URL de instruções de exclusão de dados" pública em
 * todo app que usa Login do Facebook, Instagram ou WhatsApp. Antes apontava
 * para um placeholder, e o App Review reprova isso.
 */
export default function ExclusaoDeDados() {
  return (
    <LegalPageLayout
      title="Exclusão de dados"
      subtitle="Como pedir a exclusão dos seus dados pessoais da Lead Conversa, incluindo os dados recebidos do Facebook, Instagram e WhatsApp."
      lastUpdated={COMPANY.lastUpdatedLegal}
    >
      <h2>1. Quem pode pedir</h2>
      <ul>
        <li>
          <strong>Usuários da plataforma</strong> (quem tem login na Lead Conversa) — sobre a
          própria conta e o workspace que administra.
        </li>
        <li>
          <strong>Contatos de empresas clientes</strong> — quem recebeu mensagens por WhatsApp,
          Instagram ou e-mail de uma empresa que usa a Lead Conversa. Nesse caso a empresa é a
          Controladora dos seus dados e nós somos a Operadora; atendemos o pedido e o
          encaminhamos a ela.
        </li>
        <li>
          <strong>Quem conectou uma conta da Meta</strong> (Facebook, Instagram ou WhatsApp
          Business) à Lead Conversa e quer que os dados obtidos por essa conexão sejam apagados.
        </li>
      </ul>

      <h2>2. Como pedir</h2>
      <p>Escolha o caminho mais simples para você. Todos têm o mesmo efeito.</p>
      <ol>
        <li>
          <strong>Pela plataforma:</strong> em <em>Configurações → Integrações</em>, clique em{" "}
          <em>Desconectar</em> na integração (WhatsApp, Instagram ou Meta Ads). Isso revoga o
          acesso e apaga as credenciais na hora. Para excluir a conta inteira, use{" "}
          <em>Configurações → Geral → Excluir workspace</em> ou escreva para o suporte.
        </li>
        <li>
          <strong>Por e-mail:</strong> envie uma mensagem para{" "}
          <a href={`mailto:${COMPANY.dpoEmail}?subject=Exclus%C3%A3o%20de%20dados`}>
            {COMPANY.dpoEmail}
          </a>{" "}
          com o assunto <em>"Exclusão de dados"</em>, informando o e-mail ou o número de telefone
          que deseja excluir. Podemos pedir uma confirmação de identidade antes de atender.
        </li>
        <li>
          <strong>Pela Meta:</strong> em{" "}
          <em>Facebook → Configurações → Apps e sites → Lead Conversa → Remover</em>, ou no
          WhatsApp Business → <em>Configurações → Conta → Plataforma de negócios → Desconectar</em>.
          A Meta nos notifica e o processo abaixo começa automaticamente.
        </li>
      </ol>

      <h2>3. O que é excluído</h2>
      <ul>
        <li>
          Credenciais e identificadores recebidos da Meta: tokens de acesso, IDs de conta,
          página, número e portfólio.
        </li>
        <li>Dados de perfil e contatos importados dessas plataformas.</li>
        <li>Histórico de mensagens vinculado à conta desconectada, quando solicitado.</li>
        <li>Dados de cadastro do usuário ou do workspace, no caso de exclusão da conta.</li>
      </ul>
      <p>
        Mantemos apenas o que a lei obriga, pelo prazo legal: registros de acesso (mínimo de 6
        meses, Marco Civil da Internet) e documentos fiscais (5 anos). Esses registros não são
        usados para nenhuma outra finalidade.
      </p>

      <h2>4. Prazos</h2>
      <ul>
        <li>Revogação de acesso e exclusão de credenciais: imediata.</li>
        <li>Confirmação do pedido por e-mail: até 2 dias úteis.</li>
        <li>Exclusão completa, incluindo cópias de segurança: até 30 dias.</li>
      </ul>

      <h2>5. Dúvidas</h2>
      <p>
        Fale com nosso Encarregado pelo Tratamento de Dados:{" "}
        <a href={`mailto:${COMPANY.dpoEmail}`}>{COMPANY.dpoEmail}</a>. Detalhes sobre como
        tratamos dados estão na <a href="/privacidade">Política de Privacidade</a> e no{" "}
        <a href="/lgpd">Aviso LGPD</a>.
      </p>
    </LegalPageLayout>
  );
}
